import { connect, Dispatch } from 'react-redux';
import {
    getShopifyCollections,
} from 'redux/modules/shopify';

import { IRootState } from 'redux/root_reducer';

import Nav, { INavDispatchProps, INavReduxProps, NavProps } from 'components/global/application/nav/Nav';
// TODO - StateProps should be renamed to be IBrandReduxProps or something.
import { DispatchProps, StateProps } from 'components/pages/brand/BrandsInfo';
import { sendBrandsDataRequest } from 'redux/modules/brand-info';

const mapStateToProps = ({ shopify, brandInfo, display }: IRootState): INavReduxProps & StateProps => {
    const dict = shopify.accessoriesMenuDictionary;
    if (dict) {
        const keys = Object.keys(dict);
        const types = [];
        for (const key of keys) {
            types.push(dict[key].type);
        }

        return {
            accessoriesMenuTypes: types,
            brands: brandInfo.brands,
            fetchFailed: brandInfo.failed,
            isMobile: display.isMobile,
            shopifyCollections: shopify.shopifyCollections,
            shopifyCollectionsLoading: shopify.shopifyCollectionsLoading,
        };
    }

    return {
        accessoriesMenuTypes: [],
        brands: brandInfo.brands,
        fetchFailed: brandInfo.failed,
        isMobile: display.isMobile,
        shopifyCollections: shopify.shopifyCollections,
        shopifyCollectionsLoading: shopify.shopifyCollectionsLoading,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): INavDispatchProps & DispatchProps => {
    return {
        getShopifyCollections: () => dispatch(getShopifyCollections()),
        loadBrandsInfo: () => dispatch<any>(sendBrandsDataRequest())
    };
};

export default connect<INavReduxProps, INavDispatchProps, NavProps>(mapStateToProps, mapDispatchToProps)(Nav) as any; // TODO - Fix any



// WEBPACK FOOTER //
// ./src/containers/global/application/Nav/Nav.tsx